import { useContext } from "react";
import { OrderWizardContext } from "@/pages/bestellungen/orderWizardContextValue";

export function useOrderWizard() {
  const ctx = useContext(OrderWizardContext);
  if (!ctx) {
    throw new Error("useOrderWizard() muss innerhalb von <OrderWizardProvider> verwendet werden.");
  }
  return ctx;
}
